import { X } from "lucide-react";
import { Language } from "../../../utils/dictionary";
import { dictionary } from "../../../utils/dictionary";
interface ModalDropiIntegrationProps {
    setModalOpenDropi: (open: boolean) => void;
    handlePostDropiIntegration: (token: string) => void;
    token: string;
    setToken: (token: string) => void;
    language: Language;
}

const ModalDropiIntegration = ({ setModalOpenDropi, handlePostDropiIntegration, token, setToken, language }: ModalDropiIntegrationProps) => {
    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center p-4">
            <div className="bg-white p-4 md:p-6 rounded-lg shadow-xl w-full max-w-md relative max-h-[90vh] overflow-y-auto">
                <button className="absolute top-3 md:top-4 right-3 md:right-4 z-10" onClick={() => setModalOpenDropi(false)}>
                    <X className="w-5 h-5 md:w-6 md:h-6" />
                </button>
                <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-center pr-8">{dictionary["add-integration-token"][language]}</h2>
                <label htmlFor="dropiToken" className="block text-sm font-medium text-gray-700 mb-2">
                    {dictionary["dropi-token"][language]}
                </label>
                <input
                    type="text"
                    id="dropiToken"
                    className="w-full px-3 md:px-4 py-2 text-sm md:text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder={dictionary["example-dropi-token"][language]}
                    onChange={(e) => setToken(e.target.value)}
                    value={token}
                />

                <div className="mt-4 md:mt-6 flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 sm:space-x-0">
                    <button
                        className="px-4 py-2 text-sm md:text-base bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 transition-colors w-full sm:w-auto"
                        onClick={() => setModalOpenDropi(false)}
                    >
                        {dictionary["cancel"][language]}
                    </button>
                    <button
                        className="px-4 py-2 text-sm md:text-base bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors w-full sm:w-auto"
                        onClick={() => handlePostDropiIntegration(token)}
                    >
                        {dictionary["save"][language]}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalDropiIntegration;